const stickyHeader = {
    header: document.getElementById('header') as HTMLElement,
    mainContent: document.getElementById('mainContent') as HTMLElement,
    popups: document.getElementById('popups') as HTMLElement,
    lastScrollTop: 0,

    init() {
        this.setClass();
    },

    setClass() {

        document.addEventListener('scroll', (e) => {
            let st =  document.documentElement.scrollTop;           
         
            if(st > 500 ) {
                this.header.classList.add('start');   
            }

            if(st > 600 ) {
                this.header.classList.add('prep');   
            }

            if(st > 700 ) {
                this.header.classList.add('down');    
            }

            if(st > 400 && st < 500 ) {
                this.header.classList.add('up');  
                this.header.classList.remove('start');    
                this.header.classList.remove('down');   
            }

            if(st === 0) {
                this.header.classList.remove('up');  
                this.header.classList.remove('prep');
            }

        },{passive: true})
    },
}

export default stickyHeader;